<template>
    <div class="company-detail">
        <div class="company-detail-card">
            <div class="company-detail-logo">
                <img :src="restaurant.logo" alt="">
            </div>
            <div class="company-detail-features">
                <div v-if="!restaurant.settings.deliver || !restaurant.settings.pickup">
                    <div v-if="!restaurant.settings.deliver" class="mb-1 mt-1">
                        <small class="d-flex align-items-center">
                            <icon icon="info" class="exclamation mr-1" />
                            Bezorgen is momenteel niet mogelijk.
                        </small>
                    </div>
                    <div v-if="!restaurant.settings.pickup" class="mb-1 mt-1">
                        <small  class="d-flex align-items-center">
                            <icon icon="info" class="exclamation mr-1" />
                            Afhalen is momenteel niet mogelijk.
                        </small>
                    </div>
                </div>
                <div class="item">
                    <button
                        @click="setModal('restaurantInfo')"
                        :class="[{ large: restaurant.settings.deliver && restaurant.settings.pickup }, 'button button-icon']"
                    >
                        <icon icon="info" :class="{ 'mr-1': restaurant.settings.deliver && restaurant.settings.pickup }" />
                        <template v-if="restaurant.settings.deliver && restaurant.settings.pickup">
                            Restaurantinformatie
                        </template>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '@/components/ui/Icon';
    import { mapState, mapMutations } from 'vuex';

    export default {
        name: 'CompanyDetails',
        components: {
            Icon,
        },
        data() {
            return {
                loading: true,
            };
        },
        computed: {
            ...mapState({
                restaurant: state => state.products.restaurant,
                settings: state => state.products.settings,
                workingHours: state => state.products.workingHours,
            }),
        },
        methods: {
            ...mapMutations({
                setModal: 'modal/setModal',
            }),
        },
    };
</script>

<style lang="scss">
    .company-detail {
        display: flex;
        align-items: flex-end;
        min-height: 240px;
        padding: 26px;
        margin-bottom: 26px;
        background: #e4e4e4 var(--headerImage) center center;
        background-size: cover;
        border-radius: 6px;

        &-card {
            width: 330px;
            padding: 26px;
            color: rgba(#fff, 0.4);
            background: #fff;
            border-radius: 6px;
        }

        &-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 0 16px;
            border-bottom: 1px solid rgba($mine-shaft, 0.2);
        }

        &-features {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0 0;
            color: $mine-shaft;

            .item {
                display: flex;
                align-items: center;
            }

            .star {
                margin-right: 4px;
                color: $yellow-orange;
            }
        }
    }

    .item .button-icon.large {
        width: auto;
        padding: 0 6px;
    }

    .icon {
        width: 16px !important; // stylelint-disable-line
        height: 16px !important; // stylelint-disable-line

        &.exclamation {
            transform: scaleY(-1);
        }
    }
</style>
